import React, { Component, Fragment } from "react";
import { Navigate } from "react-router-dom";

import { CommonService } from "../js_modules/CommonService";

import { SellToWebTopPanelComponent } from "../common/selltowebtoppanel/SellToWebTopPanelComponent";
import { SellToWebRightPanelComponent } from "../common/selltowebrightpanel/SellToWebRightPanelComponent";
import { SellToWebRadioButtonComponent } from "../common/selltowebradiobutton/SellToWebRadioButtonComponent";
import { SellToWebButtonComponent } from "../common/selltowebbutton/SellToWebButtonComponent";

export class VehicleConditionMMRComponent extends Component {
    accidentData = [
        { key: "Yes", value: "Yes" },
        { key: "No", value: "No" }
    ];
    exteriorData = [
        { key: "Like New", value: "Like New" },
        { key: "Very Good", value: "Very Good" },
        { key: "Acceptable", value: "Acceptable" },
        { key: "Major Issues", value: "Major Issues" }
    ];
    interiorData = [
        { key: "Like New", value: "Like New" },
        { key: "Very Good", value: "Very Good" },
        { key: "Acceptable", value: "Acceptable" },
        { key: "Major Issues", value: "Major Issues" }
    ];
    mechanicalData = [
        { key: "Like New", value: "Like New" },
        { key: "Very Good", value: "Very Good" },
        { key: "Acceptable", value: "Acceptable" },
        { key: "Major Issues", value: "Major Issues" }
    ];
    tireData = [
        { key: "Yes", value: "Yes" },
        { key: "No", value: "No" }
    ];
    windshieldData = [
        { key: "Yes", value: "Yes" },
        { key: "No", value: "No" }
    ];

    vcAccidentsContainer = React.createRef();
    vcExteriorContainer = React.createRef();
    vcInteriorContainer = React.createRef();
    vcMechanicalContainer = React.createRef();
    vcTireContainer = React.createRef();
    vcWindshieldContainer = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            selectedVCAccidents: "",
            selectedVCExterior: "",
            selectedVCInterior: "",
            selectedVCMechanical: "",
            selectedVCTire: "",
            selectedVCWindshield: "",
            isYourDetailsClicked: false,
            showSpinner: false,
            redirectTo: ""
        }

        this.onBackButtonClick = this.onBackButtonClick.bind(this);
        this.onRadioButtonListChange = this.onRadioButtonListChange.bind(this);
        this.onYourDetailsClick = this.onYourDetailsClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
    }

    pageTitle = "Vehicle Condition";

    componentDidMount() {
        let homeData = CommonService.getSessionStorage("homeData");
        let vehicleDetailsData = CommonService.getSessionStorage("vehicleDetailsData");
        try {
            if (!homeData || !vehicleDetailsData) {
                CommonService.clientAzureStorageLog("VehicleConditionMMRComponent", "componentDidMount", null, "Redirect to unique-vehicle", null, null, this.props.applicationInsights);
                this.setState({ showSpinner: false, redirectTo: "/unique-vehicle" });
            }
            else {
                CommonService.clientAzureStorageLog("VehicleConditionMMRComponent", "componentDidMount", homeData.vin, vehicleDetailsData.selectedTrim.description.trim, null, null, this.props.applicationInsights);
                window.scrollTo(0, 0);
                //Get Local Storage Data
                let lsAccident = CommonService.getLocalStorage(homeData.vin + ".Accident");
                let lsExterior = CommonService.getLocalStorage(homeData.vin + ".Exterior");
                let lsInterior = CommonService.getLocalStorage(homeData.vin + ".Interior");
                let lsMechanical = CommonService.getLocalStorage(homeData.vin + ".Mechanical");
                let lsTire = CommonService.getLocalStorage(homeData.vin + ".Tire");
                let lsWindshield = CommonService.getLocalStorage(homeData.vin + ".Windshield");

                this.setState({
                    selectedVCAccidents: lsAccident,
                    selectedVCExterior: lsExterior,
                    selectedVCInterior: lsInterior,
                    selectedVCMechanical: lsMechanical,
                    selectedVCTire: lsTire,
                    selectedVCWindshield: lsWindshield
                });
            }
        }
        catch (error) {
            console.logError(error, "VehicleConditionMMRComponent", "componentDidMount", homeData?.vin + " " + vehicleDetailsData?.selectedTrim?.description?.trim);
        }
    }

    onRadioButtonListChange(id, item) {
        try {
            this.setState({ [id]: item.value });
        }
        catch (error) {
            console.logError(error, "VehicleConditionMMRComponent", "onRadioButtonListChange", id);
        }
    }

    onYourDetailsClick() {
        let homeData = CommonService.getSessionStorage("homeData");
        let vehicleDetailsData = CommonService.getSessionStorage("vehicleDetailsData");
        try {
            let inputsValid = this.state.selectedVCExterior && this.state.selectedVCInterior && this.state.selectedVCMechanical && this.state.selectedVCTire && this.state.selectedVCWindshield;
            if (vehicleDetailsData?.autocheckData?.accidentCount === "0") {
                inputsValid = inputsValid && this.state.selectedVCAccidents;
            }

            if (inputsValid) {
                let minimumSelectedCondition = CommonService.getMinimumSelectedCondition(this.state.selectedVCExterior, this.state.selectedVCInterior, this.state.selectedVCMechanical);
                let vehicleConditionData = {
                    accidentResponse: !this.state.selectedVCAccidents ? "Yes" : this.state.selectedVCAccidents,
                    exterior: this.state.selectedVCExterior,
                    interior: this.state.selectedVCInterior,
                    mechanical: this.state.selectedVCMechanical,
                    tire: this.state.selectedVCTire,
                    windshield: this.state.selectedVCWindshield,
                    minimumSelectedCondition: minimumSelectedCondition
                };
                CommonService.setSessionStorage("vehicleConditionData", vehicleConditionData);

                //Set Local Storage
                CommonService.setLocalStorage(homeData.vin + ".Accident", this.state.selectedVCAccidents);
                CommonService.setLocalStorage(homeData.vin + ".Exterior", this.state.selectedVCExterior);
                CommonService.setLocalStorage(homeData.vin + ".Interior", this.state.selectedVCInterior);
                CommonService.setLocalStorage(homeData.vin + ".Mechanical", this.state.selectedVCMechanical);
                CommonService.setLocalStorage(homeData.vin + ".Tire", this.state.selectedVCTire);
                CommonService.setLocalStorage(homeData.vin + ".Windshield", this.state.selectedVCWindshield);
                this.setState({
                    redirectTo: "/your-details"
                });
            }
            else {
                this.scrollToTop();
            }
            this.setState({
                isYourDetailsClicked: true
            });
        }
        catch (error) {
            console.logError(error, "VehicleConditionMMRComponent", "onYourDetailsClick", homeData.vin + " " + vehicleDetailsData.selectedTrim.description.trim);
        }
    }

    onBackButtonClick() {
        try {
            window.history.go(-1);
        }
        catch (error) {
            console.logError(error, "VehicleConditionMMRComponent", "onBackButtonClick");
        }
    }

    onKeyDown(event) {
        if (event.keyCode === 13) {
            this.onYourDetailsClick();
        }
    }

    scrollToTop() {
        let scrollToElement = null;
        if (!this.state.selectedVCAccidents) {
            scrollToElement = this.vcAccidentsContainer.current;
        }
        else if (!this.state.selectedVCExterior) {
            scrollToElement = this.vcExteriorContainer.current;
        }
        else if (!this.state.selectedVCInterior) {
            scrollToElement = this.vcInteriorContainer.current;
        }
        else if (!this.state.selectedVCMechanical) {
            scrollToElement = this.vcMechanicalContainer.current;
        }
        else if (!this.state.selectedVCTire) {
            scrollToElement = this.vcTireContainer.current;
        }
        else {
            scrollToElement = this.vcWindshieldContainer.current;
        }

        if (scrollToElement) {
            let offsetPosition = scrollToElement.getBoundingClientRect().top + window.pageYOffset - 60;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    }

    render() {
        if (this.state.redirectTo) {
            return <Navigate to={this.state.redirectTo} />;
        }

        let homeData = CommonService.getSessionStorage("homeData");
        let vehicleDetailsData = CommonService.getSessionStorage("vehicleDetailsData");
        let bodyHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Vehicle Condition", "Default", "Body Html")?.Value ?? "";

        return <Fragment>
            <SellToWebTopPanelComponent imageUrl={vehicleDetailsData?.imageUrl} makePlusModel={vehicleDetailsData?.makePlusModel} trim={vehicleDetailsData?.selectedTrim?.description?.trim ?? "--"} />
            <section className="consumer-page">
                <section className="consumer-main">
                    <section className="ac-site-body ac-vehiclecondition-body" dangerouslySetInnerHTML={{ __html: bodyHtml }} />
                    <section className="ac-vehiclecondition-form" onKeyDown={(event) => this.onKeyDown(event)} tabIndex={-1}>
                        {
                            vehicleDetailsData && vehicleDetailsData?.autocheckData?.accidentCount === "0"
                                ? <Fragment>
                                    <div ref={this.vcAccidentsContainer}>
                                        <h4 className={"fw-bold " + (this.state.isYourDetailsClicked ? !this.state.selectedVCAccidents ? "consumer-vehiclecondition-border-error" : "" : "")} style={{ fontSize: "15px" }}>
                                            Accidents
                                            {
                                                this.state.isYourDetailsClicked && !this.state.selectedVCAccidents
                                                    ? <span className="fas fa-arrow-left ac-site-error consumer-vehiclecondition-error"></span>
                                                    : ""
                                            }
                                        </h4>
                                        <p style={{ fontSize: "15px", fontWeight: "500" }}>Has your vehicle been in any accidents?</p>
                                        <SellToWebRadioButtonComponent id="selectedVCAccidents" name="rblAccident" data={this.accidentData} itemKey="value" value={this.state.selectedVCAccidents ? this.state.selectedVCAccidents : ""} onChange={this.onRadioButtonListChange}></SellToWebRadioButtonComponent>
                                    </div>
                                    <hr className="consumer-vehiclecondition-seperator" />
                                </Fragment>
                                : null
                        }
                        <div ref={this.vcExteriorContainer} >
                            <h4 className={"fw-bold " + (this.state.isYourDetailsClicked ? !this.state.selectedVCExterior ? "consumer-vehiclecondition-border-error" : "" : "")} style={{ fontSize: "15px" }}>Exterior Condition  {this.state.isYourDetailsClicked ? !this.state.selectedVCExterior ? <span className="fas fa-arrow-left ac-site-error consumer-vehiclecondition-error"></span> : "" : ""}</h4>
                            <p style={{ fontSize: "15px", fontWeight: "500" }}>Condition of bumpers, fenders, doors, roof, hood and trunk.</p>
                            <SellToWebRadioButtonComponent id="selectedVCExterior" name="rblExterior" data={this.exteriorData} itemKey="value" value={this.state.selectedVCExterior ? this.state.selectedVCExterior : ""} onChange={this.onRadioButtonListChange}></SellToWebRadioButtonComponent>
                            <hr className="consumer-vehiclecondition-seperator" />
                        </div >
                        <div ref={this.vcInteriorContainer}>
                            <h4 className={"fw-bold " + (this.state.isYourDetailsClicked ? !this.state.selectedVCInterior ? "consumer-vehiclecondition-border-error" : "" : "")} style={{ fontSize: "15px" }}>Interior Condition  {this.state.isYourDetailsClicked ? !this.state.selectedVCInterior ? <span className="fas fa-arrow-left ac-site-error consumer-vehiclecondition-error"></span> : "" : ""}</h4>
                            <p style={{ fontSize: "15px", fontWeight: "500" }}>Condition of seats, carpet, headliner, dash, and equipment.</p>
                            <SellToWebRadioButtonComponent id="selectedVCInterior" name="rblInterior" data={this.interiorData} itemKey="value" value={this.state.selectedVCInterior ? this.state.selectedVCInterior : ""} onChange={this.onRadioButtonListChange}></SellToWebRadioButtonComponent>
                            <hr className="consumer-vehiclecondition-seperator" />
                        </div>
                        <div ref={this.vcMechanicalContainer}>
                            <h4 className={"fw-bold " + (this.state.isYourDetailsClicked ? !this.state.selectedVCMechanical ? "consumer-vehiclecondition-border-error" : "" : "")} style={{ fontSize: "15px" }}>Mechanical Condition  {this.state.isYourDetailsClicked ? !this.state.selectedVCMechanical ? <span className="fas fa-arrow-left ac-site-error consumer-vehiclecondition-error"></span> : "" : ""}</h4>
                            <p style={{ fontSize: "15px", fontWeight: "500" }}>Condition of engine, transmission, suspension, and brakes.</p>
                            <SellToWebRadioButtonComponent id="selectedVCMechanical" name="rblMechanical" data={this.mechanicalData} itemKey="value" value={this.state.selectedVCMechanical ? this.state.selectedVCMechanical : ""} onChange={this.onRadioButtonListChange}></SellToWebRadioButtonComponent>
                            <hr className="consumer-vehiclecondition-seperator" />
                        </div>
                        <div ref={this.vcTireContainer}>
                            <h4 className={"fw-bold " + (this.state.isYourDetailsClicked ? !this.state.selectedVCTire ? "consumer-vehiclecondition-border-error" : "" : "")} style={{ fontSize: "15px" }}>Tire Condition {this.state.isYourDetailsClicked ? !this.state.selectedVCTire ? <span className="fas fa-arrow-left ac-site-error consumer-vehiclecondition-error"></span> : "" : ""}</h4>
                            <p style={{ fontSize: "15px", fontWeight: "500" }}>Do your tires have more than 50% tread remaining? Are they all matching?</p>
                            <SellToWebRadioButtonComponent id="selectedVCTire" name="rblTire" data={this.tireData} itemKey="value" value={this.state.selectedVCTire ? this.state.selectedVCTire : ""} onChange={this.onRadioButtonListChange}></SellToWebRadioButtonComponent>
                            <hr className="consumer-vehiclecondition-seperator" />
                        </div>
                        <div ref={this.vcWindshieldContainer}>
                            <h4 className={"fw-bold " + (this.state.isYourDetailsClicked ? !this.state.selectedVCWindshield ? "consumer-vehiclecondition-border-error" : "" : "")} style={{ fontSize: "15px" }}>Windshield Condition {this.state.isYourDetailsClicked ? !this.state.selectedVCWindshield ? <span className="fas fa-arrow-left ac-site-error consumer-vehiclecondition-error"></span> : "" : ""}</h4>
                            <p style={{ fontSize: "15px", fontWeight: "500" }}>Is your windshield free of cracks and major chips?</p>
                            <SellToWebRadioButtonComponent id="selectedVCWindshield" name="rblWindshield" data={this.windshieldData} itemKey="value" value={this.state.selectedVCWindshield ? this.state.selectedVCWindshield : ""} onChange={this.onRadioButtonListChange}></SellToWebRadioButtonComponent>
                            <hr className="consumer-vehiclecondition-seperator" />
                        </div>
                        <div className="d-flex justify-content-end">
                            <div style={{ "cursor": "pointer", "fontSize": "12px", "fontWeight": "400", "textDecoration": "underline", "margin": "auto 30px" }} onClick={(event => { window.history.go(-1); })}>
                                <span className="bi bi-chevron-left" style={{ "marginRight": "5px", "verticalAlign": "middle" }} />
                                Go Back
                            </div>
                            <SellToWebButtonComponent onClick={this.onYourDetailsClick} showSpinner={this.state.showSpinner} value="Your Details" />
                        </div>
                    </section>
                </section>
                <aside className="consumer-summary">
                    <SellToWebRightPanelComponent
                        vin={homeData?.vin} makePlusModel={vehicleDetailsData?.makePlusModel} valuationMethod={"MMR"}
                        trim={vehicleDetailsData?.selectedTrim?.description?.trim ?? "--"}
                        imageUrl={vehicleDetailsData?.imageUrl} differentColorShown={vehicleDetailsData?.differentColorShown} odometer={CommonService.formatMoney(vehicleDetailsData?.odometer)}
                        colorBox={vehicleDetailsData?.selectedVehicleOEMColor?.colorBox ? CommonService.checkCSSColorSupports(vehicleDetailsData.selectedVehicleOEMColor.colorBox) : null}
                        colorName={vehicleDetailsData?.selectedVehicleOEMColor?.title ?? vehicleDetailsData?.selectedVehicleOEMColor?.optionName}
                        siteAttributes={this.props.siteAttributes} applicationInsights={this.props.applicationInsights}
                    />
                </aside>
            </section>
        </Fragment>
    }
}